import { httpRequest } from "@services/http";
import type { OpsFilters, OpsTile } from "../opsDashboard.types";
import { applyFilters } from "./filterParams";

export class CommandGetOpsTile {
    /** `accepted` asks for the rows Ops accepted as fine instead of the active ones. */
    async run(tileKey: string, filters: OpsFilters, accepted = false): Promise<OpsTile> {
        const url = new URL(
            `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/analytics/ops-dashboard/tiles/${tileKey}`
        );
        applyFilters(url, filters);
        if (accepted) url.searchParams.set("accepted", "true");
        return await httpRequest<OpsTile>(url.toString(), { method: "GET" });
    }
}
